import { animate, state, style, transition, trigger } from "@angular/animations";
import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { BusinessPartnerCreditService } from "./business-partner-credit.service";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { CompanyAttributes, CreditApplicationAttributes } from "@albatrosdeveloper/ave-models-package";
import { MatSnackBar } from "@angular/material/snack-bar";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { CompanyService } from "../../configuration/company/company.service.service";
import { BusinessPartnerService } from "../business-partner/business-partner.service";
import { ICreateBusinessPartnerCredit, IUpdatePartnerCredit } from "./interfaces/credit.interface";
import { AuthService } from "app/core/auth/auth.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { DateHelper } from "app/utils/date.helper";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { minCreditValidator } from "./business-partner-credit.util";
import MediaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/media/media.entity";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";

interface AttachmentAttributes {
  type: string;
  name: string;
  link: string;
  statusId: number;
  _id?: string;
}

@Component({
  selector: "app-business-partner-credit",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatTooltipModule,
    NgxMaskDirective,
    FilterComponent,
    HoverMenuDirective,
    FormatOtherDateHourPipe,
    FilterSectionComponent,
    FormSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    provideNgxMask()
  ],
  templateUrl: "./business-partner-credit.component.html",
  styleUrl: "./business-partner-credit.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class BusinessPartnerCreditComponent implements OnDestroy, OnInit {
  getCode = getCode;
  statusEnum = StatusEnum;

  //#region Head
  displayedColumns: string[] = [
    "det",
    "statusId",
    "statusERP",
    "subRoute",
    "businessPartner",
    "user",
    "createdAt",
    "sellerComments",
    "amountCreditRequested",
    "amountCreditApproved",
    "isExtension",
    "images",
    "action",
  ];

  totalItems = 0;
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof CreditApplicationAttributes = "id";
  sortDirection: "ASC" | "DESC" = "ASC";
  dataSource = new MatTableDataSource<CreditApplicationAttributes>([]);
  //#endregion

  //#region Detail
  selectedCredit: CreditApplicationAttributes | null = null;
  displayedColumnsDetail: string[] = ["approvalDate", "username", "approve", "approvalComments", "reasonRejection"];
  dataSourceDetail = new MatTableDataSource<any>([]);
  //#endregion

  //#region Filter
  form: FormGroup;

  selectedStatuses: number[] = []
  selectedERPStatuses: number[] = []
  selectedStatusRequestCredit: boolean[] = [];
  loadRoutesData = false;
  loadBusinessPartnersData = false;

  //#endregion 

  searchSubscription: Subscription; //BUSCADOR

  private creditRequestForm: FormGroup;
  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild("imageGalleryModal") imageGalleryModal!: TemplateRef<any>; 
  dialogRefGallery: MatDialogRef<any>;  
  dialogRef: MatDialogRef<any>;
  public id = null
  user = null

  public selectedFiles: File[] = [];
  public tooManyFilesAttempted: boolean = false;
  public previewUrls: string[] = [];

  public currentAttachments: AttachmentAttributes[] = [];
  public currentImageIndex: number = 0;

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  businessPartnerList: BusinessPartnerAttributes[] = [];
  searchBusiness = ''
  private searchSubjectBusiness = new Subject<string>();

  constructor(
    private businessPartnerCreditService: BusinessPartnerCreditService,
    private readonly searchService: SearchService,
    private readonly companyService: CompanyService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly authService: AuthService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      subRouteId: [],
      customerId: [],
      assignedUserId: [],
      searchAssignedUser: [],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
  }

  ngOnInit(): void {
    this.user = this.authService.user
    this.getList()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.getList();
      }
    );
  }

  getList(): void {
    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.sortActive,
      sortDirection: this.sortDirection,
    };

    let dataFilter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value)
        ? DateHelper.getEndOfDay(this.form.get("end")?.value)
        : DateHelper.getEndOfDay(this.form.get("start")?.value)
          ? DateHelper.getEndOfDay(this.form.get("start")?.value)
          : null,
      subRouteId: this.form.get("subRouteId")?.value,
      customerId: this.form.get("customerId")?.value,
      assignedUserId: this.form.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      requestCredit: this.selectedStatusRequestCredit.length > 0 ? this.selectedStatusRequestCredit : undefined,
    };

    this.businessPartnerCreditService
      .findAllWithCount(options, dataFilter)
      .subscribe({
        next: (res: IPaginationResult<CreditApplicationAttributes>) => {
          this.dataSource.data = res?.data?.[0]?.data ?? [];
          this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener nuevas solicitudes",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction?.toUpperCase() || "ASC";
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  toggleDetails(credit: CreditApplicationAttributes): void {
    if (this.selectedCredit && this.selectedCredit._id === credit._id) {
      this.closeDetails();
      return;
    }

    this.selectedCredit = credit;
    if (this.selectedCredit) {
      this.dataSourceDetail.data = [{
        approvalDate: this.selectedCredit.approvalDate,
        approvalUser: this.selectedCredit.approvalUser,
        approvalComments: this.selectedCredit.approvalComments,
        reasonRejection: this.selectedCredit.reasonRejection
      }];
    } else {
      this.dataSourceDetail.data = [];
    }
  }

  closeDetails(): void {
    this.selectedCredit = null;
  }

  //#region Filter
  clearFilters(): void {
    const today = new Date();
    this.form.patchValue({
      start: today,
      end: today,
      subRouteId: [],
      customerId: [],
      assignedUserId: [],
      searchAssignedUser: []
    })

    this.selectedStatuses = [];
    this.selectedERPStatuses = [];
    this.selectedStatusRequestCredit = [];
    this.getList();
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }
  //#endregion

  private buildCreditRequestForm(data?: ICreateBusinessPartnerCredit): FormGroup {
    return this.fb.group({
      sellerComments: [data?.sellerComments || ""],
      amountCreditRequested: [
        data?.amountCreditRequested || 0,
        [Validators.required, minCreditValidator('creditLimit')]
      ],
      isExtension: [data?.isExtension || false],
      userId: [data?.userId || ""],
      subRouteId: [data?.subRouteId || null],
      companyId: [data?.companyId || ""],
      businessPartnerId: [data?.businessPartnerId || ""],
      statusId: [data?.statusId || 1],
      creditLimit: [data?.creditLimit || 0],
    });
  }

  openGalleryModal(credit: CreditApplicationAttributes): void {
    const attachments = credit.attachments || [];

    const imageAttachments = attachments.filter(att => att.type === 'IMAGE' || att.link);

    if (imageAttachments.length === 0) {
      this.snackBar.open('Esta solicitud no tiene imágenes adjuntas.', 'Cerrar', { duration: 3000 });
      return;
    }

    this.currentAttachments = imageAttachments as unknown as AttachmentAttributes[];
    this.currentImageIndex = 0;

    this.dialogRefGallery = this.dialog.open(this.imageGalleryModal, {
      width: '800px',
      maxWidth: '100vw',
      maxHeight: '90vh',
      disableClose: true,
      panelClass: 'custom-dialog-container'
    });
  }

  setMainImage(index: number): void {
    if (index >= 0 && index < this.currentAttachments.length) {
      this.currentImageIndex = index;
    }
  }

  get currentImageLink(): SafeUrl | null {
    if (this.currentImageIndex >= 0 && this.currentImageIndex < this.currentAttachments.length) {
      const url = this.currentAttachments[this.currentImageIndex].link;
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return null;
  }

  //#region Form
  openCreateModal(credit?: CreditApplicationAttributes): void {
    this.getAllCompanies()
    this.getAllBusinessPartner()
    this.setupBusinessSearchControl()

    if (credit) {
      const data: ICreateBusinessPartnerCredit = {
        ...credit,
        businessPartnerId: credit.businessPartner ? credit.businessPartner._id.toString() : null,
        companyId: credit.company ? credit.company._id.toString() : null,
        subRouteId: credit.subRoute ? credit.subRoute._id.toString() : null,
        userId: credit.user ? credit.user._id.toString() : null,
        amountCreditRequested: credit.amountCreditApproved,
        sellerComments: credit.sellerComments || '',
        statusId: credit.statusId || this.statusEnum.ACTIVE
      };
      this.creditRequestForm = this.buildCreditRequestForm(data);
      this.id = credit._id
    } else {
      this.creditRequestForm = this.buildCreditRequestForm();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  //#region filter form
  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      }
    });
  }

  private getAllBusinessPartner(): void {
    let filter: IFilters = {}

    const materialOptions = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService.findAllWithCount(
      materialOptions,
      false,
      [],
      'both',
      filter // agregar filter 
    ).subscribe({
      next: (res: IPaginationResult<BusinessPartnerAttributes>) => {
        this.businessPartnerList = res?.data?.[0]?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al traer registros', 'Cerrar', { duration: 3000 });
      },
    })
  }

  changueOptionsBusiness(event) {
    this.searchSubjectBusiness.next(event)
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }

  onBusinessPartnerChange(): void {
    const selectedBusinessPartner = this.businessPartnerList.find(
      (business) => String(business._id) === this.creditRequestForm.get('businessPartnerId')?.value
    );
    if (selectedBusinessPartner.creditLimit > 0) {
      this.creditRequestForm.patchValue({
        isExtension: true,
        creditLimit: selectedBusinessPartner.creditLimit,
        amountCreditRequested: selectedBusinessPartner.creditLimit
      });
    } else {
      this.creditRequestForm.patchValue({
        isExtension: false,
        creditLimit: 0,
        amountCreditRequested: 0
      });
    }
  }

  onAmountChange(): void {
    const rawValue = this.creditRequestForm.get('amountCreditRequested')?.value;
    const numericValue = Number(String(rawValue).replace(/,/g, ''));
    const minLimit = this.creditRequestForm.get('creditLimit')?.value;

    if (minLimit && numericValue < minLimit) {
      this.creditRequestForm.get('amountCreditRequested')?.setValue(minLimit);
    }
  }
  //#endregion

  public onFilesSelected(event: any): void {
    if (!event.target.files) {
      return;
    }

    const files = Array.from(event.target.files) as File[];

    this.tooManyFilesAttempted = files.length > 3;
    this.selectedFiles = files.slice(0, 3);

    this.previewUrls = [];

    this.selectedFiles.forEach(file => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previewUrls.push(e.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.snackBar.open(`El archivo "${file.name}" no es una imagen y no se previsualizará.`, 'Cerrar', { duration: 5000 });
      }
    });

    if (this.tooManyFilesAttempted) {
      this.snackBar.open('Solo se permiten un máximo de 3 imágenes. Se han seleccionado las primeras 3.', 'Cerrar', { duration: 5000 });
    }
  }

  onSubmit() {
    const formValue = this.creditRequestForm.value;
    formValue.userId = String(this.user._id)

    if (this.id === null && this.selectedFiles.length > 3) {
      this.snackBar.open('Error: Solo se permiten un máximo de 3 archivos.', 'Cerrar', { duration: 5000 });
      return;
    }

    if (this.id === null && this.selectedFiles.length === 0) {
      this.snackBar.open('Debe adjuntar al menos un archivo para crear la solicitud.', 'Cerrar', { duration: 5000 });
      return;
    }

    if (this.id == null) {
      this.createCreditRequest()
    } else {
      this.updateCreditRequest(this.id)
    }
  }

  createCreditRequest(): void {
    const formValue = this.creditRequestForm.value;
    formValue.userId = String(this.user._id);

    const formData = new FormData();
    formData.append('data', JSON.stringify(formValue));

    this.selectedFiles.forEach(file => {
      formData.append('files', file, file.name);
    });

    this.businessPartnerCreditService.create(formData).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.selectedFiles = [];
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateCreditRequest(id: string): void {
    const formValue = this.creditRequestForm.value;
    formValue.userId = String(this.user._id);

    const updatedCredit: IUpdatePartnerCredit = {
      sellerComments: formValue.sellerComments,
      companyId: formValue.companyId ? String(formValue.companyId) : null,
      subRouteId: formValue.subRouteId ? String(formValue.subRouteId) : null,
      userId: formValue.userId ? String(formValue.userId) : null,
      amountCreditRequested: formValue.amountCreditRequested,
      statusId: formValue.statusId || this.statusEnum.ACTIVE,
      isExtension: formValue.isExtension
    };

    this.businessPartnerCreditService.update(id, updatedCredit).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }
  //#endregion

  openApprove(credit: CreditApplicationAttributes) {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: credit,
        requeriment: {
          approve: true,
          approve_generate: false,
          reject: true,
        },
        type: TypeRejectEnum.SOLICITUD_CREDITO,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Close") {
      } else {
        if (result) {
          let sendBusinessPartner = {
            approvalUserId: String(this.user._id),
            approvalComments: result.rejectedReason ?? null,
            reasonRejectionId: result.reasonRejectionId ?? null,
            statusId: result.approve ? StatusEnum.ORDER_APPROVED : StatusEnum.ORDER_REJECTED,
            amountCreditApproved: result.approve ? result.quantityCredit || 0 : 0,
            isExtension: credit.isExtension, //required to send
            approvalDate: new Date().toISOString()
          };

          this.getApprovedOrRejected(result.id, sendBusinessPartner);
        }
      }
    });
  }

  getApprovedOrRejected(id, sendBusinessPartner) {
    this.businessPartnerCreditService.update(id, sendBusinessPartner)
      .subscribe({
        next: (res: any) => {
          this.snackBar.open(
            "Registro actualizado", "Cerrar", { duration: 3000, }
          );
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al aprobar/rechazar el registro", "Cerrar", { duration: 3000 }
          );
        },
      });
  }

  openDeleteDialog(credit: CreditApplicationAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: credit, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(credit._id.toString()));
  }

  delete(id: string): void {
    this.businessPartnerCreditService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

}